/**
 *
 * Asynchronously loads the component for FullPageIframe
 *
 */

import { lazyLoad } from 'utils/loadable';

export const FullPageIframe = lazyLoad(
  () => import('./index'),
  module => module.FullPageIframe,
);
